export default "__VITE_ASSET__0942acad__"